import React from 'react';
import { AssistChip } from '@upsales/components';
import { useTranslation } from 'Components/Helpers/translate';

export type NotetakerStatusValue = { state: string; reason?: string };

export const NOTETAKER_STATUS_VISUAL: Record<
	string,
	{ type: 'success' | 'info' | 'danger' | 'alert' | 'neutral'; icon: string }
> = {
	will_join: { type: 'success', icon: 'microphone' },
	joining: { type: 'info', icon: 'microphone' },
	recording: { type: 'danger', icon: 'microphone' },
	completed: { type: 'success', icon: 'check' },
	failed: { type: 'alert', icon: 'microphone-slash' },
	wont_join: { type: 'neutral', icon: 'microphone-slash' }
};

export default function NotetakerStatusChip({ status }: { status?: NotetakerStatusValue }) {
	const { t } = useTranslation();

	if (!status?.state) {
		return null;
	}

	const visual = NOTETAKER_STATUS_VISUAL[status.state] || NOTETAKER_STATUS_VISUAL.wont_join;
	const title = t(`appointment.notetakerStatus.${status.state}`);

	return <AssistChip type={visual.type} icon={visual.icon as any} title={title} />;
}
